import { FC } from 'react';
import i18n from 'i18n/config';
import { useSelector } from 'react-redux';

import { State } from 'redux/initialState';
import {
  CouncilParticipant,
  SocietyDirector,
  SocietyDirectorType,
} from 'types';

import { getNameInitials } from 'utils/filters';
import { BLANK_PROFILE_PICTURE } from 'constants/defaultConstants';

import directorTypes from 'modules/society/components/SocietyDirectors/directorTypes';
import { getDirectorImage } from 'modules/society/utils/getDirectorImage';

type CouncilMemberAvatarProps = {
  director: SocietyDirector;
  participant?: CouncilParticipant;
  showDirectorEmail?: boolean;
  showDirectorType?: boolean;
};

export const CouncilMemberAvatar: FC<CouncilMemberAvatarProps> = ({
  director,
  participant,
  showDirectorEmail = false,
  showDirectorType = false,
}) => {
  const partners = useSelector((state: State) => state.partners);

  const getDirectorType = (director: SocietyDirector) => {
    const directorType =
      directorTypes(i18n).name[director.directorType as SocietyDirectorType];

    const firstWordOfDirectorType = directorType?.split(' ')[0];
    return firstWordOfDirectorType || '';
  };

  const directorImage = getDirectorImage(director, partners);

  const directorTypeStyle = participant?.assists
    ? 'bg-light text-dark'
    : 'bg-light';

  return (
    <>
      <div className="user-card">
        <div className="user-avatar sm bg-light mr-3">
          {directorImage && directorImage !== BLANK_PROFILE_PICTURE ? (
            <img src={directorImage} alt="member of board" />
          ) : (
            <span>{getNameInitials(director?.socialDenomination)}</span>
          )}
        </div>

        <div className="data-col flex-grow-1 flex-column align-items-start">
          <div className="data-value fw-medium">
            {director?.socialDenomination}
          </div>

          {showDirectorEmail && (
            <div className="data-label small text-muted w-100">
              {director.email}
            </div>
          )}
        </div>
      </div>

      {showDirectorType && (
        <div className="data-col d-flex justify-content-end text-ellipsis">
          <span className={`badge ${directorTypeStyle} border-0`}>
            {getDirectorType(director)}
          </span>
        </div>
      )}
    </>
  );
};
